import React from "react";
import { useNotification } from "@/hooks/useNotification";
import { CheckCircle2, AlertCircle, Info, AlertTriangle, X } from "lucide-react";

export const ToastContainer: React.FC = () => {
  const { notifications, removeNotification } = useNotification();

  if (notifications.length === 0) return null;

  return (
    <div className="toast-container" aria-live="polite">
      {notifications.map((item) => (
        <div key={item.id} className={`toast toast-${item.type}`} role="alert">
          <div className="toast-icon">
            {item.type === "success" && <CheckCircle2 size={18} />}
            {item.type === "error" && <AlertCircle size={18} />}
            {item.type === "warning" && <AlertTriangle size={18} />}
            {item.type === "info" && <Info size={18} />}
          </div>
          <div className="toast-message">{item.message}</div>
          <button
            type="button"
            className="toast-close"
            onClick={() => removeNotification(item.id)}
            aria-label="Fechar notificação"
          >
            <X size={14} />
          </button>
        </div>
      ))}
    </div>
  );
};
